/*@flow*/

export default (formula: string, value: any): any => {
  const bareFormula = formula
    .replace(/[{}]/gm, '')
    .replace('value', String(value));
  return eval(`${bareFormula}`); // eslint-disable-line no-eval
};
